import '../css/privacyterm.css'

function privacy() {
    return (
        <div>
            <p>
                表格工坊App由广州野离子网络科技有限公司研发（以下简称“本应用”），我们非常重视用户的隐私权，承诺保护用户的个人信息。请你仔细阅读本隐私政策，以便你了解我们如何收集、使用、存储和保护你的信息。
            </p>
            <h3>1、信息的收集</h3>
            <p>
                我们可能会收集以下类型的信息：
            </p>
            <ul>
                <li>个人信息：包括你的手机号、电子邮箱地等，当你注册账户或使用我们的服务时收集。</li>
                <li>使用信息：包括你如何使用本应用的信息，例如访问的页面、使用的功能和操作时间。</li>
                <li>设备信息：包括你的设备类型、操作系统、IP地址等。</li>
            </ul>
            <table className="list" border={1}>
                <tr>
                    <th colSpan={4}>表格工坊App个人信息明示清单</th>
                </tr>
                <tr>
                    <td>业务场景</td>
                    <td>收集目的</td>
                    <td>收集方式</td>
                    <td>个人信息字段</td>
                </tr>
                <tr>
                    <td>填写表格</td>
                    <td>在用户自定义表格中插入照片</td>
                    <td>用户输入</td>
                    <td>手机照片和媒体类型文件</td>
                </tr>
                <tr>
                    <td>填写表格</td>
                    <td>在用户自定义表格中插入照片</td>
                    <td>用户输入</td>
                    <td>摄像头拍摄</td>
                </tr>
                <tr>
                    <td>APP前台运行时</td>
                    <td>用于App崩溃分析</td>
                    <td>App收集</td>
                    <td>设备序列号/设备信息IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM卡IMSI/ICCID/SN/Android ID等</td>
                </tr>
                <tr>
                    <td>APP前台运行时</td>
                    <td>用于表格编辑复制粘贴</td>
                    <td>App收集</td>
                    <td>获取剪切板</td>
                </tr>
            </table>

            <h3>2、信息使用</h3>
            <p>我们可能会将收集到的信息用于以下目的：</p>
            <ul>
                <li>提供和维护我们的服务。</li>
                <li>改进和优化本应用的用户体验。</li>
                <li>为你提供客户支持</li>
            </ul>

            <h3>3、接入第三方SDK目录</h3>
            <table className="list" border={1}>
                <tr>
                    <td>第三方SDK名称</td>
                    <td>提供方</td>
                    <td>涉及个人信息类型</td>
                    <td>使用目的</td>
                    <td>第三方隐私政策链接</td>
                </tr>
                <tr>
                    <td>微信OpenSDK Android </td>
                    <td>深圳市腾讯计算机系统有限公司</td>
                    <td>设备标识信息（Android ID、OAID等）、网络信息、微信UnionID（经授权）</td>
                    <td>微信登录、分享、支付</td>
                    <td>https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</td>
                </tr>
            </table>

            <h3>4、信息分享</h3>
            <p>我们承诺不会将你的个人信息出售或出租给任何第三方。我们可能会在以下情况下共享你的信息：</p>
            <ul>
                <li>经过你的同意</li>
                <li>法律法规要求或为维护我们的合法权益</li>
            </ul>

            <h3>5、信息的存储和安全</h3>
            <p>我们将采取合理的措施保护你的个人信息免受未经授权的访问、使用或泄露。你的信息将被存储在安全的服务器上，只有经过授权的人员才能访问。</p>

            <h3>6、用户的权利</h3>
            <p>你有权访问、修改或删除我们持有的关于你的个人信息。可以在软件中账号信息界面注销账号。</p>

            <h3>7、政策的变更</h3>
            <p>我们可能会不时更新本隐私政策。我们将通过本应用发布更新的隐私政策，并注明生效日期。请定期查看，以确保你了解我们的隐私保护措施。</p>

            <h3>8、联系我们</h3>
            <p>如果你对本隐私政策有任何疑问或建议，请通过电子邮件联系我们，地址：pengdeshen_2013@qq.com</p>

            <p>感谢你使用表格工坊App，我们将竭诚为你提供服务！</p>
            <p style={{ marginTop: '20px', fontSize: 14 }}>更新日期：2024年9月28日<br />生效日期：2024年09月28日</p>
        </div>
    )
}

export default privacy;